import Box from '@mui/material/Box';
import { INK, MUTED, SECONDARY } from 'client/modules/Analyze/analyzeTheme';
import PropTypes from 'prop-types';
import React from 'react';

// Floating tooltip pinned to the top of a chart at a given horizontal
// position (percentage of chart width), edge-aware so it never overflows.
function ChartTooltip({ xPct, title, rows, footer }) {
  const align = xPct < 18 ? '0' : xPct > 82 ? '-100%' : '-50%';
  return (
    <Box
      sx={{
        position: 'absolute',
        left: `${xPct}%`,
        top: 4,
        transform: `translateX(${align})`,
        bgcolor: '#fff',
        border: '1px solid #E2E7EE',
        borderRadius: '10px',
        boxShadow: '0 6px 20px rgba(16,24,40,.12)',
        px: 1.5,
        py: 1.25,
        pointerEvents: 'none',
        zIndex: 5,
        minWidth: 168,
      }}
    >
      <Box sx={{ fontSize: 12.5, fontWeight: 700, color: INK, mb: 0.75 }}>{title}</Box>
      {rows.map(row => (
        <Box
          key={row.label}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2.5,
            fontSize: 12.5,
            py: 0.3,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, color: SECONDARY }}>
            {row.color && (
              <Box
                sx={{ width: 9, height: 9, borderRadius: '2px', bgcolor: row.color, flexShrink: 0 }}
              />
            )}
            {row.label}
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.75, flexShrink: 0 }}>
            <Box sx={{ fontWeight: 700, color: INK, fontVariantNumeric: 'tabular-nums' }}>
              {row.value}
            </Box>
            {row.sub != null && (
              <Box sx={{ fontSize: 11.5, color: MUTED, fontVariantNumeric: 'tabular-nums' }}>
                {row.sub}
              </Box>
            )}
          </Box>
        </Box>
      ))}
      {footer && (
        <Box
          sx={{
            mt: 0.75,
            pt: 0.75,
            borderTop: '1px solid #F1F4F8',
            display: 'flex',
            justifyContent: 'space-between',
            gap: 2.5,
            fontSize: 12,
            color: MUTED,
          }}
        >
          <span>{footer.label}</span>
          <Box
            component="span"
            sx={{ fontWeight: 700, color: INK, fontVariantNumeric: 'tabular-nums' }}
          >
            {footer.value}
          </Box>
        </Box>
      )}
    </Box>
  );
}

ChartTooltip.propTypes = {
  xPct: PropTypes.number.isRequired,
  title: PropTypes.node.isRequired,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.node.isRequired,
      sub: PropTypes.node,
      color: PropTypes.string,
    }),
  ).isRequired,
  footer: PropTypes.shape({ label: PropTypes.node, value: PropTypes.node }),
};

export default ChartTooltip;
